import { $$ } from '../helpers/shortcuts';

import { Luminous, LuminousGallery } from 'luminous-lightbox';

function escapeHTML(unsafe) {
  return unsafe
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#039;');
}

const galleryOptions = { arrowNavigation: true };
const lightboxOptions = {
  showCloseButton: true,
  closeOnScroll: true,
  sourceAttribute: 'data-hires-src',
  caption: (trigger) => {
    let caption = escapeHTML(trigger.dataset.titel || trigger.title);

    if (trigger.href) {
      caption +=
        ' &mdash; <a href=' +
        escapeHTML(trigger.href) +
        ' target="_blank">Herunterladen</a>';

      if (trigger.dataset.infos) {
        caption += escapeHTML(trigger.dataset.infos);
      }
    }
    return caption;
  },
};

const initializeGalleries = () => {
  const allGalleries = $$('.gallery');
  for (const gallery of allGalleries) {
    const imageLinks = gallery.querySelectorAll(':scope a');
    if (imageLinks.length === 1) {
      new Luminous(imageLinks[0], lightboxOptions);
    } else {
      new LuminousGallery(imageLinks, galleryOptions, lightboxOptions);
    }
  }
  window.Luminous = Luminous;
  window.LuminousGallery = LuminousGallery;
};

export { initializeGalleries, lightboxOptions };
